<template>
  <div id="app-inner" >
    <notification-listener/>
    <router-view/>
    <!-- demo view runs in THIS browser only — the badge makes sure it is never forgotten -->
    <div v-if="demoViewOn" class="demo-view-badge" :title="msg('demoBadgeHint')" @click="stopDemoView">
      <i class="fa-solid fa-circle-play mr-25"/> DEMO
    </div>
  </div>
</template>

<style>
html, body, #app {
  height: 100%;
}
.demo-view-badge {
  position: fixed; left: 16px; bottom: 16px; z-index: 10000;
  display: inline-flex; align-items: center;
  background: linear-gradient(135deg, #ff9f43, #e07b12);
  color: #fff; font-weight: 800; font-size: 12px; letter-spacing: .08em;
  padding: 8px 16px; border-radius: 999px; cursor: pointer; user-select: none;
  box-shadow: 0 8px 24px rgba(224, 123, 18, .5);
  animation: demo-badge-pulse 2.4s ease-in-out infinite;
}
@keyframes demo-badge-pulse {
  0%, 100% { transform: scale(1); }
  50% { transform: scale(1.06); }
}
</style>
<script>
import {mapActions, mapGetters, mapState} from 'vuex'
import $ from 'jquery'
import demoView from '@/demo/demoView'
import NotificationListener from '@core/components/toastification/NotificationListener'

export default {
  name: "login",
  components: { NotificationListener },
  watch:{
    isBodyScrollDisabled: {
      handler: function (value) {
        this.toggleBodyClass(value ? 'addClass' : 'removeClass', 'overflow-hidden')
      },
      immediate: true
    }
  },
  data() {
    return {
      demoViewOn: demoView.enabled(),
      notificationAnimation: {
        enter(element) {
          let id = parseInt($(element).data('id'));
          let elementData = this.$data.list.find(o => o.id == id);
          console.log("Notification in", elementData);
          if (elementData != null && typeof elementData.data === "object" && typeof elementData.data.onEnter == "function") {
            elementData.data.onEnter(elementData.data)
          }
          return {
            height: [element.clientHeight, 0],
          }
        },
        leave(element) {
          let id = parseInt($(element).data('id'));
          let elementData = this.$data.list.find(o => o.id == id);
          console.log("Notification out", elementData);
          if (elementData != null && typeof elementData.data === "object" && typeof elementData.data.onClose == "function") {
            elementData.data.onClose(elementData.data)
          }
          return {
            height: 0,
            opacity: 0
          }
        }
      }
    }
  },
  computed: {
    // ...mapState('user', ['status'])
    ...mapGetters('appConfig', ['isBodyScrollDisabled']),
    ...mapState({
      user: function (store) {
        return {sidebar: store.user.status, user: store.user.status};
      }
    })
  },
  created() {
    this.$root.$on('bv::modal::shown', this.autoHidePopover);
    // WhatsApp menu badge: unread guest chats, polled while logged in (skipped in background tabs)
    this.whatsappUnreadTimer = setInterval(() => this.pollWhatsappUnread(), 30000);
    this.$root.$on('crm::branch-updated', this.pollWhatsappUnread);
    setTimeout(() => this.pollWhatsappUnread(), 3000);
  },
  beforeDestroy() {
    this.$root.$off('bv::modal::shown', this.autoHidePopover);
    this.$root.$off('crm::branch-updated', this.pollWhatsappUnread);
    clearInterval(this.whatsappUnreadTimer);
  },
  methods:{
    pollWhatsappUnread() {
      const status = this.$store.state.user && this.$store.state.user.status;
      if (document.hidden || localStorage.Bearer == null || !status || status.loggedIn !== true) return;
      this.$store.dispatch('whatsapp/refreshUnread');
    },
    stopDemoView() {
      demoView.set(false)
      window.location.reload()
    },
    //Auto hide popover on modal open
    autoHidePopover() {
      this.$root.$emit('bv::hide::popover');
    },
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === 'addClass') {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
  }

}
</script>
